import { bootstrapApplication } from '@angular/platform-browser';
import { Amplify } from 'aws-amplify';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import awsconfig from './aws-exports';

Amplify.configure(awsconfig);

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
